/* eslint-disable */

import moment from 'moment'
import { useRef, useEffect } from 'react'
import Calendar from '../modules/toastui-react-calendar'
import '../modules/toastui-calendar.min.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCalendarPlus,
  faChevronLeft,
  faChevronRight,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import Modal from './Modal'
import { useNavigate } from 'react-router-dom'
import { Switch } from '@headlessui/react'

function TuiCalendar({ events, loadEvents, calendarType, userId = null }) {
  const WEEK_DAY_START = 1
  const DAY_START_HOUR = 7
  const DAY_END_HOUR = 23

  const [currentRange, setCurrentRange] = useState({
    from: moment().startOf('isoWeek'),
    to: moment().endOf('isoWeek'),
  })
  const navigate = useNavigate()
  const [availableServices, setAvailableServices] = useState([])

  const [addAvailabilityFlag, setAddAvailabilityFlag] = useState(false)
  const [addHolidayFlag, setAddHolidayFlag] = useState(false)
  const [editAvailabilityFlag, setEditAvailabilityFlag] = useState(false)
  const [editBookingFlag, setEditBookingFlag] = useState(false)
  const [viewBookingFlag, setViewBookingFlag] = useState(false)
  const [deleteAvailability, setDeleteAvailability] = useState({})
  const [deleteHoliday, setDeleteHoliday] = useState({})
  const [availabilityData, setAvailabilityData] = useState({ services: [] })
  const [availabilityDate, setAvailabilityDate] = useState('')
  const [holidayDate, setHolidayDate] = useState('')
  const [viewBookingDate, setViewBookingDate] = useState('')
  const [viewBookingSlot, setViewBookingSlot] = useState('')
  const [viewBookingClient, setViewBookingClient] = useState('')
  const [viewBookingVideoSession, setViewBookingVideoSession] = useState(false)
  const [startTimeValid, setStartTimeValid] = useState(true)
  const [endTimeValid, setEndTimeValid] = useState(true)
  const [cancelSession, setCancelSession] = useState({ reason_id: '0' })
  const [cancelReasons, setCancelReasons] = useState([])
  const [userStatusId, setUserStatusId] = useState(null)

  const [showModal, setShowModal] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const generateCalendarKeyMap = (availableServices) => {
    const keyMap = {};
    keyMap['Counselling'] = '#2f64a7'
    keyMap['CYP Counselling'] = '#eb2ae4';
    keyMap['Coaching'] = '#10b981';
    keyMap['Pending'] = '#f97316';
    keyMap['Cancelled'] = '#fca5a5';
    availableServices.forEach(service => {
      if (service.title === 'Coaching') {
        keyMap[service.title] = '#10b981';
      }
      else if (service.type_id === 1) {
        keyMap[service.title] = '#94a3b8';
      } else {
        keyMap[service.title] = service.calendar_bg_color;
      }
    });

    return keyMap;
  };

  const bookingKeyMap = generateCalendarKeyMap(availableServices);

  const [bookingLoaded, setBookingLoaded] = useState(false)
  const [availabilityLoaded, setAvailabilityLoaded] = useState(false)

  const { setShowLoader, createInfo, admin, auth, can } = useAuth()
  const axios = useAxiosPrivate()

  const loggedInUserId = auth.user.id
  const [loaded, setLoaded] = useState(false)
  const [isChecked, setIsChecked] = useState(false)

  const bookingCalendarRef = useRef()
  const availabilityCalendarRef = useRef()
  const BLOCK_OUT_COLORS = {
    bank_holiday: {
      backgroundColor: '#a78bfa',
      borderColor: '#8b5cf6',
    },
    off: {
      backgroundColor: '#fbbf24',
      borderColor: '#f59e0b',
    },
    annual_leave: {
      backgroundColor: '#34d399',
      borderColor: '#10b981',
    },
    personal_appointment: {
      backgroundColor: '#f472b6',
      borderColor: '#ec4899',
    },
    default: {
      backgroundColor: '#03a9f4',
      borderColor: '#03a9f4',
    },
  }

  useEffect(() => {
    bookingCalendarRef.current.calendarInstance.clear()
    availabilityCalendarRef.current.calendarInstance.clear()
    const data = []
    events.forEach((event) => {
      if (calendarType === 'bookings' && userId) {
        let colour
        const now = moment();
        const eventStart = moment(event.start_time);
        const eventEnd = moment(event.end_time);

        const isPendingCompletion =
          (eventEnd.isBefore(now) || eventStart.isAfter(now)) && event.confirmed !== 1;


        if (event.cancelled === 1) {
          colour = '#fca5a5'
        } else if (isPendingCompletion) {
          colour = '#f97316'
        } else if (event.service.title === 'Coaching') {
          colour = '#10b981'
        } else if (event.type_id === 1) {
          colour = '#2f64a7'
        } else {
          colour = event.service.calendar_bg_color
        }
        data.push({
          id: event.id,
          body: event.service.title,
          start: event.start_time,
          end: event.end_time,
          attendees: [event.client.name],
          color: '#fff',
          backgroundColor: colour,
          borderColor: event.service.calendar_border_color,
          raw: { ...event, isPendingCompletion: isPendingCompletion }
        })
      }

      if (calendarType === 'bookings' && !userId) {
        data.push({
          id: event.id,
          body: event.service.title,
          start: event.start_time,
          end: event.end_time,
          attendees: [event.user.name],
          color: '#fff',
          backgroundColor: event.service.calendar_bg_color,
          borderColor: event.service.calendar_border_color,
          raw: event,
        })
      }
      if (calendarType === 'availability') {
        const type = event.block_out_type
        const colors = BLOCK_OUT_COLORS[type] || BLOCK_OUT_COLORS.default

        data.push({
          id: event.id,
          start: event.start_time,
          end: event.end_time,
          attendees: [],
          color: '#fff',
          backgroundColor: colors.backgroundColor,
          borderColor: colors.borderColor,
          raw: event,
        })
      }
    })

    if (calendarType === 'bookings') {
      bookingCalendarRef.current.calendarInstance.createEvents(data)
    }
    if (calendarType === 'availability') {
      availabilityCalendarRef.current.calendarInstance.createEvents(data)
    }
  }, [events])

  const getUserServices = async () => {
    try {
      const response = await axios.get(`/users/${userId}/services`)
      setAvailableServices(response.data.result)
    } catch (error) { }
  }

  const loadUserStatus = async () => {
    try {
      const response = await axios.get(`/users/${userId}`)
      setUserStatusId(response.data.result.status_id)
    } catch (error) {
      console.error('Failed to fetch user info', error)
    }
  }

  useEffect(() => {
    if (userId) {
      getUserServices()
      loadUserStatus()
    }
  }, [])

  useEffect(() => {
    if (calendarType === 'bookings' && !bookingLoaded) {
      setBookingLoaded(true)
      bookingCalendarRef.current.calendarInstance.on(
        'selectDateTime',
        selectTime
      )
      if (userId) {
        bookingCalendarRef.current.calendarInstance.on('clickEvent', clickEvent)
      } else {
        bookingCalendarRef.current.calendarInstance.on(
          'clickEvent',
          nonUserClickEvent
        )
      }
    }
    if (calendarType === 'availability' && !availabilityLoaded) {
      setAvailabilityLoaded(true)
      availabilityCalendarRef.current.calendarInstance.on(
        'selectDateTime',
        selectTime
      )
      if (userId) {
        availabilityCalendarRef.current.calendarInstance.on(
          'clickEvent',
          clickEvent
        )
      }
    }

    loadEvents(
      moment().startOf('isoWeek').format('YYYY-MM-DD'),
      moment().endOf('isoWeek').format('YYYY-MM-DD')
    )
    setLoaded(true)
    setCurrentRange({
      from: moment().startOf('isoWeek'),
      to: moment().endOf('isoWeek'),
    })
  }, [calendarType])

  const getTimeTemplate = (schedule, isAllDay) => {
    let html = []
    let start = moment(new Date(schedule.start))
    let end = moment(new Date(schedule.end))

    if (schedule.raw?.block_out_type) {
      const label = schedule.raw.block_out_type.replace(/_/g, ' ')
      html.push(
        `<div style="font-size: 12px; font-weight: bold; margin-bottom: 3px; text-transform: capitalize; color: #fff;">${label}</div>`
      )
    }

    if (!isAllDay) {
      html.push(
        '<span style="margin-top: 5px; margin-left: 2px; display: flex">'
      )
      if (schedule.raw?.video_session === 1) {
        html.push(
          '<svg xmlns="http://www.w3.org/2000/svg" style="width: 15px; fill: white; margin-right: 4px;" viewBox="0 0 576 512"><path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" /></svg>'
        )
      }
      html.push(
        '<svg style="width: 15px; fill: white; margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg><strong style="font-size: 12px">' +
        start.format('HH:mm') +
        ' - ' +
        end.format('HH:mm') +
        '</strong></span>'
      )
    }
    if (schedule.raw?.services) {
      html.push(
        '<div style="display: flex; flex-direction: column; margin-top: 5px">'
      )
      schedule.raw.services.forEach((service) => {
        html.push(
          `<span class="badge badge-pill mb-1 mr-1" style="background: ${service.calendar_bg_color};">${service.title}</span>`
        )
      })
      html.push('</div>')
    }

    if (schedule.isPending) {
      html.push('<i title="Pending" class="far fa-hourglass-half"></i>')
      html.push(' ' + schedule.title + ' ')
      html.push('<span style="font-weight: lighter;">Pending</span>')
    } else if (schedule.raw && schedule.raw.isCancelled) {
      html.push('<i title="Cancelled" class="far fa-do-not-enter"></i>')
      html.push(' ' + schedule.title + ' ')
      html.push('<span style="font-weight: lighter;">Cancelled</span>')
    } else {
      html.push(' ' + schedule.title)
    }

    return html.join('')
  }

  const getPopupDetailBody = (schedule) => {
    const html = []

    if (schedule.isPending) {
      html.push('(Pending)')
    }
    if (schedule.raw && schedule.raw.isCancelled) {
      html.push('(Cancelled)')
    }
    html.push(schedule.body)

    return html.join('\n')
  }

  const goToToday = () => {
    setLoaded(false)
    setCurrentRange({
      from: moment().startOf('isoWeek'),
      to: moment().endOf('isoWeek'),
    })
    calendarType === 'bookings'
      ? bookingCalendarRef.current.calendarInstance.today()
      : availabilityCalendarRef.current.calendarInstance.today()
  }

  const nextWeek = () => {
    setLoaded(false)
    setCurrentRange({
      from: moment(currentRange.from).add(7, 'days'),
      to: moment(currentRange.to).add(7, 'days'),
    })
    calendarType === 'bookings'
      ? bookingCalendarRef.current.calendarInstance.next()
      : availabilityCalendarRef.current.calendarInstance.next()
  }

  const prevWeek = () => {
    setLoaded(false)
    setCurrentRange({
      from: moment(currentRange.from).subtract(7, 'days'),
      to: moment(currentRange.to).subtract(7, 'days'),
    })
    calendarType === 'bookings'
      ? bookingCalendarRef.current.calendarInstance.prev()
      : availabilityCalendarRef.current.calendarInstance.prev()
  }

  const loadCalendar = () => {
    setLoaded(true)
    loadEvents(
      currentRange.from.format('YYYY-MM-DD'),
      currentRange.to.format('YYYY-MM-DD')
    )
  }

  const visitClient = (id) => {
    navigate(`/clients/${id}`)
  }

  const addBooking = (day = null, time = null) => {
    // 
  }

  const addAvailability = (
    date = moment().format('YYYY-MM-DD'),
    time = { start: '11:00', end: '12:00' }
  ) => {
    let allServices = []
    availableServices.forEach((service) => {
      if (service.status !== 'Disabled') allServices.push(service.id)
    })
    setAvailabilityDate(date)
    setAvailabilityData({
      start: time.start,
      end: time.end,
      services: allServices,
      repeat_until: moment(date).add(6, 'months').format('YYYY-MM-DD'),
    })
    setAddAvailabilityFlag(true)
    setModalTitle(`Add Availability Slot`)
    setShowModal(true)
  }

  const addHolidayClicked = (
    date = moment().format('YYYY-MM-DD'),
    time = { start: '11:00', end: '12:00' }
  ) => {
    setAddHolidayFlag(true)
    setModalTitle(`Add Holiday Slot`)
    setShowModal(true)
  }

  const deleteAvailabilityClicked = (availability) => {
    setShowModal(false)
    setEditAvailabilityFlag(false)
    setAddHolidayFlag(false)
    setDeleteAvailability(availability)
    setModalTitle(`Delete Availability`)
    setShowModal(true)
  }

  const deleteHolidayClicked = (availability) => {
    setShowModal(false)
    setEditAvailabilityFlag(false)
    setAddHolidayFlag(false)
    setDeleteHoliday(availability)
    setModalTitle(`Delete Holiday`)
    setShowModal(true)
  }

  const cancelBookingClicked = (booking) => {
    setShowModal(false)
    setEditBookingFlag(false)
    setViewBookingFlag(false)
    setCancelSession(booking)
    setModalTitle(`Cancel Session`)
    setShowModal(true)
  }

  const editAvailability = (event) => {
    let allServices = []
    event = { ...event.raw }
    event.services.forEach((service) => {
      if (service.status !== 'Disabled') allServices.push(service.id)
    })
    setAvailabilityDate(moment(event.start_time).format('YYYY-MM-DD'))
    event.start = moment(event.start_time).format('HH:mm')
    event.end = moment(event.end_time).format('HH:mm')
    event.services = allServices
    setAvailabilityData(event)
    setEditAvailabilityFlag(true)
    setModalTitle(`Edit Availability`)
    setShowModal(true)
  }

  const editHolidays = async (event) => {
    const clicked = event.raw
    const parentId = clicked.parent_id ?? clicked.id

    try {
      const res = await axios.get(
        `/users/${userId}/availability/group/${parentId}`
      )
      const group = res.data.result.group
      const earliest = res.data.result.earliest_start_time
      const latest = res.data.result.latest_end_time
      const currentItem = group.find((item) => item.id === clicked.id)

      const formatted = {
        id: currentItem.id,
        parent_id: currentItem.parent_id ?? null,
        user_id: currentItem.user_id,
        block_out_type: currentItem.block_out_type,
        start_date: moment(earliest).format('YYYY-MM-DD'),
        end_date: moment(latest).format('YYYY-MM-DD'),
        start: moment(currentItem.start_time).format('HH:mm'),
        end: moment(currentItem.end_time).format('HH:mm'),
        all_day:
          moment(currentItem.start_time).format('HH:mm') === '00:00' &&
          moment(currentItem.end_time).format('HH:mm') === '23:59',
        notes: currentItem.notes || '',
      }

      setHolidayDate(formatted)
      setAddHolidayFlag(true)
      setModalTitle(`Edit Holiday`)
      setShowModal(true)
    } catch (err) {
      console.error(err)
      createInfo('error', 'Could not load holiday group')
    }
  }

  const editBooking = (event) => {
    let allBookings = []
    event = { ...event.raw }
    setViewBookingDate(moment(event.start_time).format('YYYY-MM-DD'))
    event.start = moment(event.start_time).format('HH:mm')
    event.end = moment(event.end_time).format('HH:mm')
    event.services = allBookings
    setViewBookingSlot(event)
    setViewBookingClient(event.client)
    if (event.video_session === 1) {
      setViewBookingVideoSession(true)
    } else {
      setViewBookingVideoSession(false)
    }
    setEditBookingFlag(true)
    setModalTitle(`Edit Session`)
    setShowModal(true)
  }

  const viewBookingDetails = (event) => {
    let allBookings = []
    event = { ...event.raw }
    setViewBookingDate(moment(event.start_time).format('YYYY-MM-DD'))
    event.start = moment(event.start_time).format('HH:mm')
    event.end = moment(event.end_time).format('HH:mm')
    event.services = allBookings
    setViewBookingSlot(event)
    setViewBookingClient(event.client)
    if (event.video_session === 1) {
      setViewBookingVideoSession(true)
    } else {
      setViewBookingVideoSession(false)
    }
    setViewBookingFlag(true)
    setModalTitle(`View Session`)
    setShowModal(true)
  }

  const selectTime = (e) => {
    const day = moment(e.start).format('YYYY-MM-DD')
    const start = moment(e.start).format('HH:mm')
    const end = moment(e.end).format('HH:mm')
    if (calendarType === 'bookings') {
      addBooking(day, { start, end })
    }
    if (calendarType === 'availability') {
      addAvailability(day, { start, end })
    }
  }

  const clickEvent = (e) => {
    const eventDate = moment(e.event.raw.end_time).format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')

    if (calendarType === 'availability') {
      if (e.event.raw.block_out_type) {
        editHolidays(e.event)
      } else {
        editAvailability(e.event)
      }
    } else if (calendarType === 'bookings') {
      if (eventDate < today) {
        viewBookingDetails(e.event)
      } else {
        editBooking(e.event)
      }
    }
  }

  const nonUserClickEvent = (e) => {
    if (calendarType === 'bookings') {
      viewBookingDetails(e.event)
    }
  }

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked)
    loadEvents(
      currentRange.from.format('YYYY-MM-DD'),
      currentRange.to.format('YYYY-MM-DD'),
      !isChecked
    )
  }

  const ModalBody = () => {
    if (addAvailabilityFlag) {
      return <AddAvailabilityElement />
    }

    if (addHolidayFlag) {
      return (
        <AddHolidayElement
          isEdit={!!holidayDate?.id}
          existingHoliday={holidayDate}
        />
      )
    }

    if (editAvailabilityFlag) {
      return <EditAvailabilityElement />
    }

    if (deleteAvailability.id) {
      return <DeleteAvailabilityElement />
    }

    if (deleteHoliday.id) {
      return <DeleteHolidayElement />
    }

    if (editBookingFlag) {
      return <EditSessionElement />
    }

    if (viewBookingFlag) {
      return <ViewSessionElement />
    }

    if (cancelSession.id) {
      return <CancelSessionElement />
    }
  }

  const intervals = (start, end) => {
    start = moment(start, 'HH:mm')
    end = moment(end, ' HH:mm')

    start.minutes(Math.ceil(start.minutes() / 15) * 15)

    let result = []

    let current = moment(start)

    while (current <= end) {
      result.push(current.format('HH:mm'))
      current.add(15, 'minutes')
    }

    return result
  }

  const checkTime = (start, end) => {
    setStartTimeValid(true)
    setEndTimeValid(true)
    if (
      moment(end, 'HH:mm').format('HH:mm') <=
      moment(start, 'HH:mm').format('HH:mm')
    ) {
      return false
    }
    return true
  }

  const AddAvailabilityElement = () => {
    const addAvailability = async (e) => {
      e.preventDefault()

      if (!startTimeValid || !endTimeValid) {
        createInfo('error', `The start time must be before the end time`)
        return
      }
      availabilityData.date = availabilityDate
      availabilityData.repeat = availabilityData.repeat || 0

      setShowLoader(true)
      try {
        const response = await axios.post(
          `/users/${userId}/availability/add`,
          availabilityData
        )
        if (response.data.error === false) {
          const availability = response.data.result
          createInfo('success', `Availability Added`)
          availabilityCalendarRef.current.calendarInstance.createEvents([
            {
              id: availability.id,
              start: availability.start_time,
              end: availability.end_time,
              attendees: [],
              color: '#fff',
              backgroundColor: '#03a9f4',
              borderColor: '#03a9f4',
              raw: availability,
            },
          ])
          availabilityCalendarRef.current.calendarInstance.clearGridSelections()
          resetModal()
        }
      } catch (error) { }
      setShowLoader(false)
    }

    const updateAvailabilityServices = (service) => {
      let index = availabilityData.services.indexOf(service.id)
      if (index === -1) {
        availabilityData.services.push(service.id)
      } else {
        availabilityData.services.splice(index, 1)
      }
    }

    return (
      <form onSubmit={addAvailability}>
        <div className="mb-3">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              required
              type="date"
              name="date"
              id="date"
              defaultValue={availabilityDate}
              onChange={(e) => {
                setAvailabilityDate(e.target.value)
                availabilityData.repeat_until = moment(e.target.value)
                  .add(6, 'months')
                  .format('YYYY-MM-DD')
              }}
              min={moment().format('YYYY-MM-DD')}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className={`mb-3 ${!startTimeValid ? 'select-error' : ''}`}>
          <label
            htmlFor="start"
            className="block font-medium text-gray-600 text-sm"
          >
            Start
          </label>
          <select
            defaultValue={availabilityData.start}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => {
              const valid = checkTime(e.target.value, availabilityData.end)
              setStartTimeValid(valid)
              availabilityData.start = e.target.value
            }}
          >
            <option disabled>Select Start Time</option>
            {intervals('7:00', '23:45')?.map((time) => {
              return (
                <option key={time} value={time}>
                  {time}
                </option>
              )
            })}
          </select>
          {!startTimeValid && (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="error-icon"
            />
          )}
        </div>

        <div className={`mb-3 ${!endTimeValid ? 'select-error' : ''}`}>
          <label
            htmlFor="end"
            className="block font-medium text-gray-600 text-sm"
          >
            End
          </label>
          <select
            defaultValue={availabilityData.end}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => {
              const valid = checkTime(availabilityData.start, e.target.value)
              setEndTimeValid(valid)
              availabilityData.end = e.target.value
            }}
          >
            <option disabled>Select End Time</option>
            {intervals('7:00', '23:45')?.map((time) => {
              return (
                <option key={time} value={time}>
                  {time}
                </option>
              )
            })}
          </select>
          {!endTimeValid && (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="error-icon"
            />
          )}
        </div>

        <div className="mt-3 w-full mr-2">
          <h3 className="block font-medium text-gray-600 text-sm">Services</h3>
          <div className="flex flex-wrap w-full">
            {availableServices?.map((service) => {
              if (service.status === 'Disabled') return null
              return (
                <div className="flex items-center mr-4" key={service.id}>
                  <div className="relative mr-2">
                    <input
                      type="checkbox"
                      id={service.id}
                      value={service.id}
                      defaultChecked={availabilityData.services.includes(
                        service.id
                      )}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                      onChange={() => updateAvailabilityServices(service)}
                    />
                  </div>
                  <label
                    htmlFor={service.id}
                    className="block font-medium text-gray-600 text-sm"
                  >
                    {service.title}
                  </label>
                </div>
              )
            })}
          </div>
        </div>

        <div className="mt-3">
          <h3 className="block font-medium text-gray-600 text-sm">Repeat</h3>
          <div className=" w-full mr-2 flex items-center">
            <div className="relative mr-2">
              <input
                type="checkbox"
                id="repeat"
                onChange={(e) => {
                  setAvailabilityData({
                    start: availabilityData.start,
                    end: availabilityData.end,
                    services: availabilityData.services,
                    repeat: e.target.checked,
                    repeat_until: availabilityData.repeat_until,
                  })
                }}
                placeholder="Repeat Availability"
                className="field"
                checked={availabilityData.repeat}
              />
            </div>
            <label
              htmlFor="repeat"
              className="block font-medium text-gray-600 text-sm"
            >
              Every {moment(availabilityDate).format('dddd')}{' '}
              <span className="text-red-400">(for a maximum of 6 months)</span>
            </label>
          </div>
        </div>

        {availabilityData.repeat && (
          <div className="mt-3">
            <label
              htmlFor="date"
              className="block font-medium text-gray-600 text-sm"
            >
              Repeat Until
            </label>
            <div className="mt-1 relative rounded-md">
              <input
                required
                type="date"
                name="date"
                id="date"
                max={moment(availabilityDate)
                  .add(6, 'months')
                  .format('YYYY-MM-DD')}
                defaultValue={availabilityData.repeat_until}
                onChange={(e) =>
                  (availabilityData.repeat_until = e.target.value)
                }
                min={moment().format('YYYY-MM-DD')}
                className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
              />
            </div>
          </div>
        )}

        <div className="flex mt-2 w-full">
          <button className="btn mt-4 mr-4 w-1/2">Add Availability</button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const AddHolidayElement = ({ isEdit = false, existingHoliday = null }) => {
    useEffect(() => {
      if (isEdit && existingHoliday && !availabilityData.id) {
        const formatted = {
          id: existingHoliday.id,
          parent_id: existingHoliday.parent_id || null,
          block_out_type: existingHoliday.block_out_type,
          start_date: existingHoliday.start_date,
          start: existingHoliday.start,
          end: existingHoliday.end,
          all_day: !!existingHoliday.all_day,
          notes: existingHoliday.notes || '',
          user_id: existingHoliday.user_id,
        }
        setAvailabilityData(formatted)
      }
    }, [isEdit, existingHoliday, availabilityData.id])

    const addOrUpdateHoliday = async (e) => {
      e.preventDefault()

      if (!availabilityData.all_day && (!startTimeValid || !endTimeValid)) {
        createInfo('error', `The start time must be before the end time`)
        return
      }

      setShowLoader(true)

      try {
        const payload = {
          block_out_type: availabilityData.block_out_type,
          start_date: availabilityData.start_date,
          end_date: availabilityData.start_date,
          all_day: availabilityData.all_day,
          notes: availabilityData.notes || '',
          ...(availabilityData.all_day
            ? {}
            : {
              start: availabilityData.start,
              end: availabilityData.end,
            }),
        }

        const endpoint = isEdit
          ? `/users/${userId}/availability/update-holidays/${availabilityData.id}`
          : `/users/${userId}/availability/holidays`

        const method = isEdit ? axios.put : axios.post
        const response = await method(endpoint, payload)

        if (response.data.error === false) {
          const blockouts = Array.isArray(response.data.result)
            ? response.data.result
            : [response.data.result]
          const type = blockouts[0].block_out_type
          const events = blockouts.map((availability) => {
            const colors = BLOCK_OUT_COLORS[type] || BLOCK_OUT_COLORS.default

            return {
              id: availability.id,
              start: availability.start_time,
              end: availability.end_time,
              attendees: [],
              color: '#fff',
              backgroundColor: colors.backgroundColor,
              borderColor: colors.borderColor,
              raw: availability,
            }
          })

          availabilityCalendarRef.current.calendarInstance.createEvents(events)
          availabilityCalendarRef.current.calendarInstance.clearGridSelections()
          resetModal()
          const formattedType = type
            .replace(/_/g, ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')

          createInfo('success', `${formattedType} ${isEdit ? 'Updated' : 'Added'}`)
          loadEvents(
            currentRange.from.format('YYYY-MM-DD'),
            currentRange.to.format('YYYY-MM-DD')
          )
        }
      } catch (error) {
        console.error(error)
        createInfo('error', 'Something went wrong')
      }

      setShowLoader(false)
    }

    return (
      <form onSubmit={addOrUpdateHoliday}>
        <div className="mb-3">
          {availabilityData.parent_id && (
            <div className="mb-3 text-sm text-gray-500 italic">
              This block out is part of a group starting from:{' '}
              {moment(availabilityData.start_date).format('DD/MM/YYYY')}
            </div>
          )}
          <label
            htmlFor="holiday_type"
            className="block font-medium text-gray-600 text-sm"
          >
            Holiday Type
          </label>
          <div className="mt-1 relative rounded-md">
            <select
              required
              name="holiday_type"
              id="holiday_type"
              value={availabilityData.block_out_type || ''}
              onChange={(e) =>
                setAvailabilityData({
                  ...availabilityData,
                  block_out_type: e.target.value,
                })
              }
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            >
              <option value="" disabled>
                Select Holiday Type
              </option>
              <option value="bank_holiday">Bank Holiday</option>
              <option value="off">Off</option>
              <option value="annual_leave">Annual Leave</option>
              <option value="personal_appointment">Personal Appointment</option>
            </select>
          </div>
        </div>

        {/* Start & End Date */}
        <div className="grid grid-cols-2 gap-4 mb-3">
          <div>
            <label
              htmlFor="start_date"
              className="block font-medium text-gray-600 text-sm"
            >
              Date of Holiday
            </label>
            <input
              type="date"
              id="start_date"
              required
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
              value={availabilityData.start_date || ''}
              onChange={(e) =>
                setAvailabilityData({
                  ...availabilityData,
                  start_date: e.target.value,
                })
              }
              min={moment().format('YYYY-MM-DD')}
            />
          </div>
        </div>

        {/* All Day Toggle */}
        <div className="mb-2 flex items-center space-x-2">
          <input
            type="checkbox"
            id="all_day"
            checked={availabilityData.all_day || false}
            onChange={(e) => {
              const all_day_checked = e.target.checked
              setAvailabilityData((prev) => ({
                ...prev,
                all_day: all_day_checked,
                ...(all_day_checked ? {} : { end_date: prev.start_date }),
              }))
            }}
          />
          <label
            htmlFor="all_day"
            className="text-sm font-medium text-gray-600"
          >
            All Day
          </label>
        </div>

        {/* Start & End Time */}
        <div className="grid grid-cols-2 gap-4 mb-3">
          <div className={`${!startTimeValid ? 'select-error' : ''}`}>
            <label
              htmlFor="start_time"
              className="block font-medium text-gray-600 text-sm"
            >
              Start Time
            </label>
            <select
              id="start_time"
              disabled={availabilityData.all_day}
              required={!availabilityData.all_day}
              value={availabilityData.start || ''}
              className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
              onChange={(e) => {
                const valid = checkTime(e.target.value, availabilityData.end)
                setStartTimeValid(valid)
                setAvailabilityData({
                  ...availabilityData,
                  start: e.target.value,
                })
              }}
            >
              <option disabled>Select Start Time</option>
              {intervals('7:00', '23:45')?.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </select>
          </div>

          <div className={`${!endTimeValid ? 'select-error' : ''}`}>
            <label
              htmlFor="end_time"
              className="block font-medium text-gray-600 text-sm"
            >
              End Time
            </label>
            <select
              id="end_time"
              disabled={availabilityData.all_day}
              required={!availabilityData.all_day}
              value={availabilityData.end || ''}
              className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
              onChange={(e) => {
                const valid = checkTime(availabilityData.start, e.target.value)
                setEndTimeValid(valid)
                setAvailabilityData({
                  ...availabilityData,
                  end: e.target.value,
                })
              }}
            >
              <option disabled>Select End Time</option>
              {intervals('7:00', '23:45')?.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Notes */}
        {availabilityData.user_id === loggedInUserId && (
          <div className="mb-3">
            <label
              htmlFor="notes"
              className="block font-medium text-gray-600 text-sm"
            >
              Notes
            </label>
            <textarea
              id="notes"
              rows={3}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
              defaultValue={availabilityData.notes || ''}
              onChange={(e) => (availabilityData.notes = e.target.value)}
              placeholder="Private notes for your reference"
            />
          </div>
        )}
        {isEdit && can('delete notes') && (
          <div className="mb-3">
            <div className="flex justify-end">
              <p
                className="text-red-500 text-sm cursor-pointer hover:text-red-700 hover:underline"
                onClick={() => deleteAvailabilityClicked(availabilityData)}
              >
                Delete Occurence
              </p>
            </div>
          </div>
        )}

        {/* Buttons */}
        <div className="flex mt-2 w-full">
          <button type="submit" className="btn mt-4 mr-4 w-1/2">
            {isEdit ? 'Update Holiday' : 'Add Holiday'}
          </button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const EditAvailabilityElement = () => {
    const updateAvailability = async (e) => {
      e.preventDefault()

      if (!startTimeValid || !endTimeValid) {
        createInfo('error', `The start time must be before the end time`)
        return
      }
      availabilityData.date = availabilityDate

      setShowLoader(true)
      try {
        const response = await axios.post(
          `/availabilities/update/${availabilityData.id}`,
          availabilityData
        )
        if (response.data.error === false) {
          createInfo('success', `Availability Updated`)
          setShowLoader(true)
          loadEvents(
            currentRange.from.format('YYYY-MM-DD'),
            currentRange.to.format('YYYY-MM-DD')
          )
          setShowLoader(false)
          resetModal()
        }
      } catch (error) { }
      setShowLoader(false)
    }

    const updateAvailabilityServices = (service) => {
      let index = availabilityData.services.indexOf(service.id)
      if (index === -1) {
        availabilityData.services.push(service.id)
      } else {
        availabilityData.services.splice(index, 1)
      }
    }

    return (
      <form onSubmit={updateAvailability}>
        <fieldset
          disabled={userStatusId === 3}
          className={
            userStatusId === 3 ? 'opacity-60 pointer-events-none mb-3' : 'mb-3'
          }
        >
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              required
              type="date"
              name="date"
              id="date"
              defaultValue={availabilityDate}
              onChange={(e) => {
                setAvailabilityDate(e.target.value)
                availabilityData.repeat_until = moment(e.target.value)
                  .add(6, 'months')
                  .format('YYYY-MM-DD')
              }}
              min={moment().format('YYYY-MM-DD')}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </fieldset>

        <fieldset
          disabled={userStatusId === 3}
          className={`mb-3 ${!startTimeValid ? 'select-error' : ''}`}
        >
          <label
            htmlFor="start"
            className="block font-medium text-gray-600 text-sm"
          >
            Start
          </label>
          <select
            defaultValue={availabilityData.start}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => {
              const valid = checkTime(e.target.value, availabilityData.end)
              setStartTimeValid(valid)
              availabilityData.start = e.target.value
            }}
          >
            <option disabled>Select Start Time</option>
            {intervals('7:00', '23:45')?.map((time) => {
              return (
                <option key={time} value={time}>
                  {time}
                </option>
              )
            })}
          </select>
          {!startTimeValid && (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="error-icon"
            />
          )}
        </fieldset>

        <fieldset
          disabled={userStatusId === 3}
          className={`mb-3 ${!endTimeValid ? 'select-error' : ''}`}
        >
          <label
            htmlFor="end"
            className="block font-medium text-gray-600 text-sm"
          >
            End
          </label>
          <select
            defaultValue={availabilityData.end}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => {
              const valid = checkTime(availabilityData.start, e.target.value)
              setEndTimeValid(valid)
              availabilityData.end = e.target.value
            }}
          >
            <option disabled>Select End Time</option>
            {intervals('7:00', '23:45')?.map((time) => {
              return (
                <option key={time} value={time}>
                  {time}
                </option>
              )
            })}
          </select>
          {!endTimeValid && (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="error-icon"
            />
          )}
        </fieldset>

        <fieldset disabled={userStatusId === 3} className="mt-3 w-full mr-2">
          <h3 className="block font-medium text-gray-600 text-sm">Services</h3>
          <div className="flex flex-wrap w-full">
            {availableServices?.map((service) => {
              if (service.status === 'Disabled') return null
              return (
                <div className="flex items-center mr-4" key={service.id}>
                  <div className="relative mr-2">
                    <input
                      type="checkbox"
                      id={service.id}
                      value={service.id}
                      defaultChecked={availabilityData.services.includes(
                        service.id
                      )}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                      onChange={() => updateAvailabilityServices(service)}
                    />
                  </div>
                  <label
                    htmlFor={service.id}
                    className="block font-medium text-gray-600 text-sm"
                  >
                    {service.title}
                  </label>
                </div>
              )
            })}
          </div>
        </fieldset>

        <div className="flex items-center justify-end mt-2 space-x-2">
          <div className="flex justify-end">
            <p
              className="text-red-500 text-sm cursor-pointer hover:text-red-700 hover:underline"
              onClick={() => deleteAvailabilityClicked(availabilityData)}
            >
              Delete Occurence
            </p>
          </div>
          {availabilityData.repeating === 1 &&
            availabilityData.repeat_end_date && (
              <>
                {' '}
                |{' '}
                <div className="flex justify-end">
                  <p
                    className="text-red-500 text-sm cursor-pointer hover:text-red-700 hover:underline"
                    onClick={() =>
                      deleteAvailabilityClicked({
                        ...availabilityData,
                        delete_all: true,
                      })
                    }
                  >
                    Delete All Occurrences
                  </p>
                </div>
              </>
            )}
        </div>
        <div className="flex mt-2 w-full">
          {userStatusId !== 3 && (
            <button className="btn mt-4 mr-4 w-1/2">Update</button>
          )}
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const EditSessionElement = () => {
    const updateBooking = async (e) => {
      e.preventDefault()
      let video_session = 0
      if (viewBookingVideoSession) {
        video_session = 1
      } else {
        video_session = 0
      }
      const data = {
        start_time:
          moment(viewBookingDate).format('YYYY-MM-DD') +
          ' ' +
          viewBookingSlot.start +
          ':00',
        end_time:
          moment(viewBookingDate).format('YYYY-MM-DD') +
          ' ' +
          viewBookingSlot.end +
          ':00',
        video_session: video_session,
      }

      if (!startTimeValid || !endTimeValid) {
        createInfo('error', `The start time must be before the end time`)
        return
      }

      let isTimeAvailable = true

      events.map((event) => {
        if (
          event.user_id === viewBookingSlot.user_id &&
          viewBookingSlot.id !== event.id
        ) {
          // The third parameter 'undefined' is the unit of time to compare eg. 'year'.
          // The fourth (last) parameter is used so check if the date is the same as the start / end date since it could be the same but not in between
          const startTimeIsDuring = moment(data.start_time).isBetween(
            event.start_time,
            event.end_time,
            undefined,
            '[)'
          )
          const endTimeIsDuring = moment(data.end_time).isBetween(
            event.start_time,
            event.end_time,
            undefined,
            '(]'
          )

          const startTimeOverlaps = moment(event.start_time).isBetween(
            data.start_time,
            data.end_time,
            undefined,
            '[)'
          )
          const endTimeOverlaps = moment(event.end_time).isBetween(
            data.start_time,
            data.end_time,
            undefined,
            '(]'
          )

          if (
            startTimeOverlaps ||
            endTimeOverlaps ||
            startTimeIsDuring ||
            endTimeIsDuring
          ) {
            isTimeAvailable = false
            return false
          }
        } else if (viewBookingSlot.id === event.id) {
          if (viewBookingVideoSession) {
            event.video_session = 1
          } else {
            event.video_session = 0
          }
        }
      })

      if (!isTimeAvailable) {
        createInfo('error', `A session is already booked during this time`)
        return
      }

      viewBookingSlot.date = viewBookingDate
      setShowLoader(true)
      try {
        const response = await axios.post(
          `/sessions/update/${viewBookingSlot.id}`,
          data
        )
        if (response.data.error === false) {
          createInfo('success', `Session Updated`)
          setShowLoader(true)
          loadEvents(
            currentRange.from.format('YYYY-MM-DD'),
            currentRange.to.format('YYYY-MM-DD')
          )
          setShowLoader(false)
          resetModal()
        }
      } catch (error) {
        console.error(error)
      }
      setShowLoader(false)
    }

    return (
      <form onSubmit={updateBooking}>
        <div className="mb-3">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              required
              type="date"
              name="date"
              id="date"
              defaultValue={viewBookingDate}
              onChange={(e) => {
                setViewBookingDate(e.target.value)
              }}
              min={moment().format('YYYY-MM-DD')}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-4">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Client
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              required
              type="text"
              name="client_name"
              id="client_name"
              disabled="disabled"
              defaultValue={viewBookingClient.name}
              onChange={(e) => {
                setViewBookingClient(e.target.value)
              }}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
            <p
              className="text-blue-500 text-sm cursor-pointer hover:text-blue-700 float-right"
              onClick={() => visitClient(viewBookingClient.id)}
            >
              View client
            </p>
          </div>
        </div>

        <div className="flex mb-3">
          <p className="mr-4">Video Session:</p>
          <Switch
            checked={viewBookingVideoSession}
            onChange={(e) => {
              setViewBookingVideoSession(e)
            }}
            className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
          >
            <span className="sr-only">Is this a video session</span>
            <span className="pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5">
              <span
                aria-hidden="true"
                className="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in group-data-[checked]:opacity-0 group-data-[checked]:duration-100 group-data-[checked]:ease-out"
              >
                <svg
                  fill="none"
                  viewBox="0 0 12 12"
                  className="h-3 w-3 text-gray-400"
                >
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span
                aria-hidden="true"
                className="absolute inset-0 flex h-full w-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-data-[checked]:opacity-100 group-data-[checked]:duration-200 group-data-[checked]:ease-in"
              >
                <svg
                  fill="currentColor"
                  viewBox="0 0 12 12"
                  className="h-3 w-3 text-indigo-600"
                >
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              </span>
            </span>
          </Switch>
        </div>

        <div className={`mb-3 ${!startTimeValid ? 'select-error' : ''}`}>
          <label
            htmlFor="start"
            className="block font-medium text-gray-600 text-sm"
          >
            Start
          </label>
          <select
            defaultValue={viewBookingSlot.start}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => {
              const valid = checkTime(e.target.value, viewBookingSlot.end)
              setStartTimeValid(valid)
              viewBookingSlot.start = e.target.value
            }}
          >
            <option disabled>Select Start Time</option>
            {intervals('7:00', '23:45')?.map((time) => {
              return (
                <option key={time} value={time}>
                  {time}
                </option>
              )
            })}
          </select>
          {!startTimeValid && (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="error-icon"
            />
          )}
        </div>

        <div className={`mb-3 ${!endTimeValid ? 'select-error' : ''}`}>
          <label
            htmlFor="end"
            className="block font-medium text-gray-600 text-sm"
          >
            End
          </label>
          <select
            defaultValue={viewBookingSlot.end}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => {
              const valid = checkTime(viewBookingSlot.start, e.target.value)
              setEndTimeValid(valid)
              viewBookingSlot.end = e.target.value
            }}
          >
            <option disabled>Select End Time</option>
            {intervals('7:00', '23:45')?.map((time) => {
              return (
                <option key={time} value={time}>
                  {time}
                </option>
              )
            })}
          </select>
          {!endTimeValid && (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="error-icon"
            />
          )}
        </div>

        {admin && (
          <div className="w-full flex justify-end">
            <p
              className="text-red-500 text-sm cursor-pointer hover:text-red-700"
              onClick={() => cancelBookingClicked(viewBookingSlot)}
            >
              Cancel Session
            </p>
          </div>
        )}

        <div className="flex mt-2 w-full">
          <button className="btn mt-4 mr-4 w-1/2">Update</button>

          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const ViewSessionElement = () => {
    const eventEndDate = moment(viewBookingSlot.end_time).format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')
    const isPastEvent = eventEndDate < today

    return (
      <div>
        <div className="mb-3">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              readOnly
              type="date"
              name="date"
              id="date"
              defaultValue={viewBookingDate}
              min={moment().format('YYYY-MM-DD')}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Client
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              readOnly
              type="text"
              name="client_name"
              id="client_name"
              disabled="disabled"
              defaultValue={viewBookingClient.name}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
            <p
              className="text-blue-500 text-sm cursor-pointer hover:text-blue-700 float-right"
              onClick={() => visitClient(viewBookingClient.id)}
            >
              View client
            </p>
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            Start
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              readOnly
              type="text"
              name="start"
              id="start"
              defaultValue={viewBookingSlot.start}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="date"
            className="block font-medium text-gray-600 text-sm"
          >
            End
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              readOnly
              type="text"
              name="end"
              id="end"
              defaultValue={viewBookingSlot.end}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        {admin && !isPastEvent && (
          <div className="w-full flex justify-end">
            <p
              className="text-red-500 text-sm cursor-pointer hover:text-red-700"
              onClick={() => cancelBookingClicked(viewBookingSlot)}
            >
              Cancel Session
            </p>
          </div>
        )}

        <div className="flex mt-2 w-full justify-end">
          <button type="button" className="btn mt-4 w-1/2" onClick={resetModal}>
            Close
          </button>
        </div>
      </div>
    )
  }

  const DeleteAvailabilityElement = () => {
    const deleteAvailabilityFn = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      resetModal(false)
      try {
        await axios.get(
          `/availabilities/delete/${deleteAvailability.id}` +
          (deleteAvailability.delete_all ? '?delete_all=true' : '')
        )

        createInfo(
          'error',
          deleteAvailability.repeating === 1 && deleteAvailability.delete_all
            ? 'All future occurrences deleted'
            : 'Availability Deleted'
        )

        setShowLoader(true)
        loadEvents(
          currentRange.from.format('YYYY-MM-DD'),
          currentRange.to.format('YYYY-MM-DD')
        )
        setShowLoader(false)
      } catch (error) {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={deleteAvailabilityFn}>
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            {deleteAvailability.repeating === 1 && deleteAvailability.delete_all
              ? 'Are you sure you want to delete all future occurrences of this availability?'
              : 'Are you sure you want to delete this availability?'}
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn red mt-4 mr-4 w-1/2">Delete</button>

            <button
              type="button"
              className="btn mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  const DeleteHolidayElement = () => {
    const deleteAvailabilityFn = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      resetModal(false)
      try {
        await axios.get(`/availabilities/delete/holiday/${deleteHoliday.id}`)

        createInfo(
          'error',
          deleteHoliday.parent_id ? 'Holiday Block deleted' : 'Holiday Deleted'
        )

        setShowLoader(true)
        loadEvents(
          currentRange.from.format('YYYY-MM-DD'),
          currentRange.to.format('YYYY-MM-DD')
        )
        setShowLoader(false)
      } catch (error) {
        setShowLoader(false)
      }
      resetModal(true)
    }

    return (
      <form onSubmit={deleteAvailabilityFn}>
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            {deleteHoliday.parent_id !== null
              ? 'Are you sure you want to delete this holiday block?'
              : 'Are you sure you want to delete this holiday?'}
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn red mt-4 mr-4 w-1/2">Delete</button>

            <button
              type="button"
              className="btn mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  useEffect(() => {
    getCancelReasons()
  }, [])

  const getCancelReasons = async (e) => {
    try {
      const response = await axios.get('/cancel-reasons/all')
      setCancelReasons(response.data.result)
    } catch (error) {
      console.error(error)
    }
    setShowLoader(false)
  }

  const handleChange = (e) => {
    setCancelSession({ ...cancelSession, reason_id: e.target.value })
  }

  const CancelSessionElement = () => {
    const cancelSessionFn = async (e) => {
      e.preventDefault()
      if (!cancelSession.reason_id) {
        createInfo('error', 'Please select a cancellation reason')
        return
      }
      setShowLoader(true)
      resetModal(false)
      try {
        await axios.get(
          '/sessions/delete/' + cancelSession.id + '/' + cancelSession.reason_id
        )
        createInfo('error', `Session Cancelled`)
        setShowLoader(true)
        loadEvents(
          currentRange.from.format('YYYY-MM-DD'),
          currentRange.to.format('YYYY-MM-DD')
        )
        setShowLoader(false)
      } catch (error) {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={cancelSessionFn}>
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            Are you sure you want to cancel this session?
          </p>
          <div>
            <label
              htmlFor="end"
              className="block font-medium text-gray-600 text-sm"
            >
              Please select a reason for cancelling this booking
            </label>
            <select
              value={cancelSession.reason_id ?? 0}
              className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
              required
              onChange={handleChange}
            >
              <option value="0" disabled>
                Select Cancel Reason
              </option>
              {cancelReasons?.map((reason) => {
                return (
                  <option key={reason.id} value={reason.id}>
                    {reason.title}
                  </option>
                )
              })}
            </select>
          </div>
          {cancelSession.reason_id && cancelSession.reason_id !== 0 && (
            <div className="flex content-center mt-4">
              <span className="content-center text-red-600">
                {JSON.parse(cancelSession.reason_id).id === 1 ||
                  JSON.parse(cancelSession.reason_id).id === 2 ||
                  JSON.parse(cancelSession.reason_id).id === 6
                  ? 'Make sure you let the client know, they will not be able to get this session back.'
                  : "This session will not be taken from the client's allowance."}
              </span>
            </div>
          )}
          <div className="flex mt-2 w-full">
            <button
              type="submit"
              className={`mt-4 mr-4 w-1/2 ${!cancelSession.reason_id || cancelSession.reason_id === '0'
                ? 'cursor-not-allowed text-sm inline-flex justify-center items-center bg-gray-500 border-gray-500 text-white font-bold py-2.5 px-4 border rounded'
                : 'btn blue'
                }`}
              disabled={
                !cancelSession.reason_id || cancelSession.reason_id === '0'
              }
            >
              Yes, cancel this session
            </button>

            <button
              type="button"
              className="btn red mt-4 w-1/2"
              onClick={resetModal}
            >
              No
            </button>
          </div>
        </div>
      </form>
    )
  }

  const resetModal = () => {
    setAddAvailabilityFlag(false)
    setAddHolidayFlag(false)
    setAvailabilityData({ services: [] })
    setViewBookingSlot({})
    setAvailabilityDate('')
    setViewBookingDate('')
    setStartTimeValid(true)
    setEndTimeValid(true)

    setAvailabilityData({
      id: null,
      parent_id: null,
      block_out_type: '',
      start_date: '',
      end_date: '',
      start: '',
      end: '',
      all_day: false,
      notes: '',
      services: [],
    })

    setHolidayDate(null)
    setEditAvailabilityFlag(false)
    setEditBookingFlag(false)
    setViewBookingFlag(false)
    setDeleteHoliday({})
    setShowModal(false)
    setModalTitle('')
  }

  return (
    <div>
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      {/* Nav */}
      <div className="mb-4 flex justify-between">
        <div className="flex">
          <button
            className="h-10 px-6 rounded-full border border-slate-300 bg-white text-sm font-medium flex items-center mr-4 hover:bg-slate-300"
            onClick={goToToday}
          >
            Today
          </button>

          <button
            className="h-10 w-10 rounded-full border border-slate-300 bg-white text-sm font-medium flex items-center justify-center mr-2 hover:bg-slate-300"
            onClick={prevWeek}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <button
            className="h-10 w-10 rounded-full border border-slate-300 bg-white text-sm font-medium flex items-center justify-center mr-4 hover:bg-slate-300"
            onClick={nextWeek}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>

          <span className="text-lg h-10 font-medium flex items-center justify-center">
            {moment(currentRange.from).format('DD/MM/YYYY')} -{' '}
            {moment(currentRange.to).format('DD/MM/YYYY')}
          </span>
        </div>

        <div className="flex">
          {calendarType === 'bookings' && userId && (
            <div className="flex items-center">
              <input
                type="checkbox"
                id="cancelledCheckbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label className="ml-1" htmlFor="cancelledCheckbox">
                Show Cancellations
              </label>
            </div>
          )}
          {/* {calendarType === 'bookings' && (
            <button
              className="btn ml-3 green"
              onClick={() => addBooking(moment().format('YYYY-MM-DD'))}
            >
              <FontAwesomeIcon icon={faCalendarPlus} className="mr-2" />
              Book
            </button>
          )} */}
          {calendarType === 'availability' &&
            userId &&
            userStatusId !== 3 &&
            ![1, 159].includes(loggedInUserId) && (
              <>
                <button
                  className="btn ml-3 green"
                  onClick={() => addAvailability(moment().format('YYYY-MM-DD'))}
                >
                  <FontAwesomeIcon icon={faCalendarPlus} className="mr-2" />
                  Add Availability
                </button>
                <button
                  className="btn ml-3 green"
                  onClick={() =>
                    addHolidayClicked(moment().format('YYYY-MM-DD'))
                  }
                >
                  <FontAwesomeIcon icon={faCalendarPlus} className="mr-2" />
                  Add Holiday
                </button>
              </>
            )}
          {!loaded && (
            <button className="btn ml-3" onClick={loadCalendar}>
              Load Calendar
            </button>
          )}
        </div>
      </div>
      {calendarType == 'bookings' && (
        <div className="flex flex-wrap items-center space-x-4 mb-4">
          <span className="font-semibold mt-2">Key:</span>
          {Object.entries(bookingKeyMap).map(([label, color]) => (
            <div key={label} className="flex items-center mt-2">
              <span
                className="block w-4 h-4 rounded-full mr-2"
                style={{
                  backgroundColor: color,
                  border: `1px solid ${color === '#fff' || color === '#fca5a5' ? '#ccc' : color}`
                }}
              ></span>
              <span className="text-sm">{label}</span>
            </div>
          ))}

        </div>
      )}


      <div className="w-full h-full rounded-xl shadow-md overflow-hidden relative">
        {!loaded && (
          <div
            onClick={loadCalendar}
            className="absolute cursor-pointer w-full h-full opacity-40 bg-white z-10 flex justify-center items-center"
          >
            <p className="text-2xl xl:text-4xl text-black">
              Click here or 'Load Calendar' to view
            </p>
          </div>
        )}
        <div
          className={`calendar-block ${calendarType === 'availability' ? 'hidden' : ''
            }`}
        >
          <Calendar
            ref={bookingCalendarRef}
            defaultView="month"
            taskView={false}
            disableDblClick={true}
            useCreationPopup={false}
            useDetailPopup={false}
            scheduleView={['time']}
            gridSelection={false}
            week={{
              startDayOfWeek: WEEK_DAY_START,
              hourStart: DAY_START_HOUR,
              hourEnd: DAY_END_HOUR,
              taskView: false,
              eventView: ['time'],
            }}
            template={{
              time: function (schedule) {
                return getTimeTemplate(schedule, false)
              },
              popupEdit: function () {
                return 'Edit'
              },
              popupDetailBody: function (schedule) {
                return getPopupDetailBody(schedule)
              },
            }}
          />
        </div>
        <div
          className={`calendar-block ${calendarType === 'bookings' ? 'hidden' : ''
            }`}
        >
          <Calendar
            style={{ height: '100%', width: '100%' }}
            ref={availabilityCalendarRef}
            defaultView="week"
            taskView={false}
            disableDblClick={true}
            useCreationPopup={false}
            useDetailPopup={false}
            scheduleView={['time']}
            gridSelection={false}
            week={{
              startDayOfWeek: WEEK_DAY_START,
              hourStart: DAY_START_HOUR,
              hourEnd: DAY_END_HOUR,
              taskView: false,
              eventView: ['time'],
            }}
            template={{
              time: function (schedule) {
                return getTimeTemplate(schedule, false)
              },
              popupEdit: function () {
                return 'More'
              },
              popupDetailBody: function (schedule) {
                return getPopupDetailBody(schedule)
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default TuiCalendar
